import React from 'react'
import { Button, Container, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import { grey } from '@material-ui/core/colors'
import HomeIcon from '@material-ui/icons/Home'
import Logo from '../../assets/Ads Logo_LightMode.svg'
import Login from '../../components/login/Login'
// import Verification from "../../components/verification/VerificationCard"
import './Sign.css'

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      fontWeight: '800',
      textDecoration: 'none'
    }
  },
  button: {
    color: grey[100]
  },
  call: {
    '& > *': {
      marginTop: theme.spacing(4),
      fontWeight: '600'
    }
  }
}))

export default function SignPage() {
  const mobile = useMediaQuery('(max-width: 600px)')
  const classes = useStyles()
  return (
    <div className="signpage">
      <header>
        <Container className="header-container">
          <img className="logo" src={Logo} alt="logo" />
          {mobile ? (
            <div className={classes.root}>
              <Button
                component={Link}
                to="/"
                color="secondary"
                className={classes.button}
                variant="contained"
                disableElevation>
                <HomeIcon />
              </Button>
            </div>
          ) : (
            <div className={classes.root}>
              <Button
                component={Link}
                to="/"
                color="secondary"
                className={classes.button}
                variant="contained"
                startIcon={<HomeIcon />}
                disableElevation>
                Home
              </Button>
            </div>
          )}
        </Container>
      </header>
      <div className="logincard">
        <Login />
        {/* <Verification /> */}
      </div>
    </div>
  )
}
